import React, { useState, useEffect, Fragment } from 'react';
import {
    Card,
    CardBody,
    Button,
    TabContent,
    TabPane,
    NavItem,
    Modal,
    ModalHeader,
    ModalFooter,
    ModalBody,
    Input,
    CardHeader,
    Nav,
} from 'reactstrap';
import '../../style/style.css';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import { Separator } from '../../../../../../components/common/CustomBootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import '../../style/style.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { post_API_Send_Email } from '../../../../../../constants/APIs';
import SEOSettings from './SEOSettings';


export default function SpaceStandAloneCodeSnippet({ integration, propertyId, saveIntegration }) {

    const [activeTab, setActiveTab] = useState('seo');
    const [showEmailBox, setShowEmailBox] = useState(false);
    const [developerEmail, setDeveloperEmail] = useState('');
    const [directLink, setDirectLink] = useState('');
    const [directLinkCopied, setDirectLinkCopied] = useState('');

    useEffect(() => {
        const gid = getGroupID();
        const iid = integration.id;
        const link = `${process.env.REACT_APP_WEBVIEW}/spaces?iid=${integration.id}&gid=${getGroupID()}`;
        setDirectLink(link);
    }, []);


    const toggleAppMenu = (tab) => {
        setActiveTab(tab);
    };

    const SendEmail = () => {

        let data = {
            'groupId': getGroupID(), intregationId: integration.id,
            'Email': developerEmail, 'PropertyId': propertyId
        };
        AxiosAPI({
            method: 'post',
            url: `${post_API_Send_Email}`,
            data,
        })
            .then((res) => {
                NotificationManager.success(
                    '',
                    'Email sended successfully',
                    2000,
                    null,
                    null,
                    'success'
                );
            })
    };
    return (
        <Fragment>
            <Card className="mb-4">
                <CardBody name="bodyClick text-center">
                    <div className="col-md-12 text-center">
                        <h4>Publish your Space Booking</h4>
                        <p className="mb-3">
                            Define SEO settings and create your unique URL
                        </p>
                    </div>
                    <Separator className="mb-2" />
                    <Nav tabs className="separator-tabs ml-0 mr-0">
                        <NavItem className="w-20 text-center">
                            <NavLink
                                style={{ marginRight: "0px" }}
                                to="#"
                                location={{}}
                                className={classnames({
                                    active: activeTab === 'seo',
                                    'nav-link': true,
                                })}
                                onClick={() => toggleAppMenu('seo')}
                            >
                                SEO Settings
                            </NavLink>
                        </NavItem>
                    </Nav>
                    <TabContent activeTab={activeTab} className="">
                        <TabPane tabId="seo" className="chat-app-tab-pane">
                            <SEOSettings
                                pageSettings={integration.spaceStandalonePageIntegration.pageSettings}
                                integration={integration}
                                propertyId={propertyId}
                                saveIntegration={saveIntegration}
                            />
                        </TabPane>
                    </TabContent>
                </CardBody>
            </Card>
            <Modal className='intregation-modal-content' style={{ borderRadius: '10px' }} isOpen={showEmailBox} toggle={() => setShowEmailBox(!showEmailBox)}>
                <ModalHeader toggle={() => setShowEmailBox(!showEmailBox)}>
                    Your developer`s e-mail address:
                </ModalHeader>
                <ModalBody>
                    <p>
                        Your developer teammate will receive an e-mail containing the code
                        and necessary instructions to implement it.
                    </p >
                    <p >
                        <Input
                            className='mt-2'
                            style={{ borderRadius: '10px' }}
                            type="text"
                            name="email"
                            value={developerEmail}
                            placeholder="E-mail"
                            onChange={(e) => setDeveloperEmail(e.target.value)}
                        />
                    </p>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="success"
                        size="xs"
                        style={{ marginTop: '10px', marginLeft: '20px' }}
                        onClick={() => { SendEmail(); setDeveloperEmail(''); setShowEmailBox(!showEmailBox); }}
                    >
                        <FontAwesomeIcon icon={faEnvelope}></FontAwesomeIcon><span className='ml-2' >Send</span>
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}
